import React, { useState } from 'react';
import { Card } from '../../../components/Card/Card';
import { Icon } from '../../../components/Icon/Icon';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { Modal } from '../../../components/Modal/Modal';
import { t } from '../../../locales/translate';
import { Company } from '../../../model/company';
import { isAdmin, useSelectedMembership } from '../../../model/membership';
import { BankDetailsForm } from '../BankDetailsModal/BankDetailsForm';

interface Props {
  company: Company;
}

export function AccountsPaymentsTaxes({ company }: Props): JSX.Element {
  const membership = useSelectedMembership();
  const [displayModal, setDisplayModal] = useState(false);

  return (
    <>
      <Card
        title={t.model.company.accountsPaymentsTaxes}
        elevation={1}
        className="company-details__bank-details"
        actions={
          company.$permissions.includes('update') &&
          isAdmin(membership) && (
            <span onClick={() => setDisplayModal(true)}>
              <Icon style={{ cursor: 'pointer' }} name="edit" />
            </span>
          )
        }
      >
        <p>{t.model.company.billingInfo}</p>
        {!company.bankAccount ? (
          <div>{t.model.company.noBankDetails}</div>
        ) : (
          <KeyValueTable
            items={[
              {
                key: t.model.bank.vatId,
                value: company.vatId,
              },
              {
                key: t.model.bank.taxNumber,
                value: company.vatNumber,
                style: { height: '38px' },
              },
              {
                key: t.model.bank.holdersName,
                value: company.bankAccount.name,
              },
              {
                key: t.model.bank.iban,
                value: company.bankAccount.iban,
              },
              {
                key: t.model.bank.bic,
                value: company.bankAccount.bic,
                style: { height: '38px' },
              },
              {
                key: t.model.reference.eventCreditorReference,
                value: company.eventCreditorReference,
              },
              {
                key: t.model.reference.merchCreditorReference,
                value: company.merchCreditorReference,
              },
            ]}
          />
        )}
      </Card>
      <Modal open={displayModal} title={t.actions.edit(t.model.bank.bankDetails)} size="small">
        <BankDetailsForm company={company} onClose={() => setDisplayModal(false)} />
      </Modal>
    </>
  );
}
